import React, {createRef} from "react";
import {DataGrid} from "devextreme-react";
import DataSource, {DataSourceOptions} from "devextreme/data/data_source";
import styles from "./OrdersArchiveScreenComponent.module.scss";
import {Box, Item} from "devextreme-react/box";
import {FilterRow, LoadPanel, Pager, Paging} from "devextreme-react/data-grid";
import {RouteComponentProps} from "react-router";
import {OrdersArchiveScreenProps} from "./OrdersArchiveScreen";

interface OrdersArchiveScreenComponentState {
    
    
}

export default class OrdersArchiveScreenComponent extends React.Component<OrdersArchiveScreenComponentProps, OrdersArchiveScreenComponentState> {
    constructor(props: OrdersArchiveScreenComponentProps) {
        super(props);
        //
        this.state = {
            
        };
    }

    render() {
        return (
            <div className={styles.container}>
                
            </div>
        );
    }
}

type OrdersArchiveScreenComponentProps = OrdersArchiveScreenProps & RouteComponentProps<{}>